import Input from 'components/shared/Input/Input';
import s from '../Vouchers.module.scss';
import Button from 'components/shared/Button/Button';
import CloseIcon from '../../../../../../images/new-icons/cross-thin-black.svg';
import { VoucherCard } from '../VoucherCard';
import { useParams } from 'react-router-dom';
import useGetSalonById from 'sdk/hooks/salon/useGetSalonById';
import { validateEmail } from 'sdk/utils/validation';
import Textarea from 'components/shared/Input/Textarea';
import { useTranslation } from 'react-i18next';

type EmailStepProps = {
  email: string;
  message: string;
  setEmail: (email: string) => void;
  setMessage: (message: string) => void;
  onNext: () => void;
  onBack: () => void;
  voucherData: any;
  error?: boolean;
};

const EmailStep: React.FC<EmailStepProps> = ({
  email,
  setEmail,
  message,
  setMessage,
  onNext,
  onBack,
  voucherData,
  error,
}) => {
  const { id } = useParams();
  const { data } = useGetSalonById(id);
  const isEmailValid = validateEmail(email);
  const { t } = useTranslation() as any;
  return (
    <div className={s.vouchers_step}>
      <img src={CloseIcon} alt="email" onClick={onBack} className={s.vouchers_step_close} />
      <div className={s.vouchers_step_stage}>
        <div className={s.vouchers_step_stage_active}></div>
        <div className={s.vouchers_step_stage_inactive}></div>
        <div className={s.vouchers_step_stage_inactive}></div>
      </div>
      <div className={s.vouchers_step_voucher}>
        <VoucherCard
          style={{ marginTop: '25px' }}
          variant={voucherData?.color?.toLowerCase()}
          {...voucherData}
        />
      </div>

      <h3 className={s.vouchers_step_title}>Enter the recipient's email</h3>
      <p className={s.vouchers_step_description}>Add e-mail address</p>
      <Input
        type="email"
        gray
        value={email}
        onChangeValue={setEmail}
        placeholder="Enter email address"
        className={s.vouchers_step_input}
        error={(email.length > 0 && !isEmailValid) || error}
        errorMessage={
          email.length > 0 && !isEmailValid
            ? 'Please enter a valid email address'
            : error
            ? 'Such a user with this email does not exist.'
            : ''
        }
      />
      <p className={s.vouchers_step_description}>Message to the recipient</p>
      <Textarea
        gray
        value={message}
        onChange={setMessage}
        placeholder="Type something"
        className={s.vouchers_step_textarea}
      />
      <Button
        className={s.vouchers_step_buttons}
        darkGreen
        wide
        onClick={onNext}
        disabled={!isEmailValid}
      >
        {t('next')}
      </Button>
    </div>
  );
};

export default EmailStep;

